<template>
  <div class="home">
    <banner-Component :bList="bList"></banner-Component>
   <div class="main">
<!--    关于我们-->
       <div class="about">
        <div class="title wow fadeInUp">
          {{$t('home').about.text0}}
        </div>
           <div class="intro">
               <p class="wow fadeInUp">
                   {{$t('home').about.text1[0]}}<br>
                   {{$t('home').about.text1[1]}}
               </p>
               <div class="wow fadeInUp">
                   <img src="../assets/ycb/about.png" alt="">
               </div>
               <div class="btn wow fadeInUp" @click="gotoAbout">
                {{$t('btn')}}
               </div>
           </div>

       </div>

        <customer class="wow  fadeInUp" />

       <!--       新闻中心-->
       <news class="wow fadeInUp" />

<!--       产品中心-->
       <mpro class="wow fadeInUp" :list="list1" />


       <div class="market wow fadeInUp">
           <div class="l">
               <p>
                   {{$t('home').market.text0[0]}}{{$t('home').market.text0[1]}}
               </p>
           </div>
           <hmap />
       </div>

       <honor :list="list2" />


   </div>
      <foot-Component class="foot wow fadeIn" ></foot-Component>
  </div>
</template>

<script>
  import bannerComponent from '../components/banner'
  import Scrollbar from 'smooth-scrollbar'
  import { CountUp } from 'countup.js'
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  import footComponent from '../components/foot'
  import mpro from '../components/mpro'
  import hmap from '../components/hmap'
  import honor from '../components/honor'
  import news from '../components/news'
  import customer from '../components/customer'
  import  {getHomeInfo} from "../util/lang";

  export default {
  name: 'home',
    data(){
      return{
          scrollbar:'',
          bList:[],
          list1:[],
          list2:[]
      }
    },
    mounted() {
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.scrollTo(0,0)
        this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
        window.pageYOffset=this.scrollbar.scrollTop
        this.scrollbar.addListener((status) => {

        });
        this.getNews()
    },
  components:{bannerComponent,footComponent,swiper, swiperSlide,mpro,news,customer,hmap,honor},
    methods:{
        getNews(){
            const url = `${getHomeInfo()}`
            this.$axios.get(url).then(res => {
                this.bList=res.data.banner
                this.list1=res.data.products
                this.list2=res.data.references
            })
        },
        gotoInfo(n){
            const link=`/newsInfo.html?id=${n}`
            window.open(link,'_blank')
        },
        count(){
            let element=this.$refs.counts;
            let actualTop = element.offsetTop;
            let current = element.offsetParent;
            while (element=element.offsetParent){
                actualTop += element.offsetTop;
                /* current = current.offsetParent; */
            }
            let demoFi1 = new CountUp("num1", 1500);
            let demoFi2 = new CountUp("num2", 7500);
            let demoFi3 = new CountUp("num3", 200);
            // demoFi1.start();
            // demoFi2.start();
            // demoFi3.start();
            let numok=false;
            let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            if(scrollbar){
                scrollbar.addListener((status) => {
                    if(!numok){
                        if(actualTop<status.offset.y+document.body.clientHeight){
                            demoFi1.start();
                            demoFi2.start();
                            demoFi3.start();
                            numok=true;
                        }
                    }
                });
            }
        },
        gotoAbout(){
            const link='/about.html'
            window.open(link,'_self')
        },
        gotoNews(){
            const link='/news.html'
            window.open(link,'_self')
        },
     change(n){
       this.select=n
     }
    }
}
</script>

<style lang="scss" scoped>
.home{
  width:100%;
    animation: run5 1s linear forwards;
    @keyframes run5 {
        from{
            opacity: 0;
        }
        to{
            opacity: 1;
        }
    }
  .main{
    width:100%;
     .about{
       width:80%;
         margin: 60px auto;
         text-align: center;
         .title{
             color:#263346;
             font-size: 50px;
             font-family: "DINEngschriftStd";
             text-transform: uppercase;
         }
         .intro{
             width:80%;
             margin: 40px auto;
             p{
                 color:#263346;
                 line-height: 40px;
                 font-family: "itbook";
                 font-size: 18px;
                 text-align: justify;
             }
             div{
                 margin: 40px auto;
                 height:500px;
                 overflow: hidden;
                 img{
                     max-width: 100%;
                     object-fit: cover;
                     cursor: pointer;
                     transition: all 600ms;
                     &:hover{
                         transform: scale(1.05);
                     }
                 }
             }
             .btn{
                 width:181px;
                 height:40px;
                 border:1px solid rgba(145,145,145,1);
                 border-radius:20px;
                 transition: all 600ms;
                 margin: 0 auto;
                 line-height: 40px;
                 text-transform: uppercase;
                 font-family: "it";
                 cursor: pointer;
                 &:hover{
                     background-color: #1C8B48;
                     color:white;
                 }
             }
         }
     }
      .market{
          width:100%;
          background-color: #263346;
          display: flex;
          flex-direction: row;
          justify-content: center;
          padding: 80px 0;
          animation-duration: 2s;
          .l{
              p:nth-child(1){
                  color:white;
                  font-size: 35px;
                  font-family: "DINEngschriftStd";
                  text-transform: uppercase;
                  position: relative;
                  padding: 40px 0;
                  line-height: 45px;
                  &::after{
                      content:'';
                      display: inline-block;
                      width:77px;
                      height:1px;
                      background:rgba(13,121,59,1);
                      position: absolute;
                      bottom:0;
                      left:0;
                  }
              }
          }
      }
  }
    .foot{
      animation-duration: 5s;
    }
  @keyframes transition1 {
    0% {
      transform: translate(-100px,100px);
      opacity: 0;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    }
  }
  @keyframes transition2 {
    0% {
      transform: translate(100px,-100px);
      opacity: 0;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    }
  }
  @keyframes polygon {
    0% {
        clip-path: polygon(100% 0, 99% 50%, 50% 99%,100% 50%);
        opacity: 0;
    }
    100% {
      clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
        opacity: 1;
    }
  }

  @media screen  and (min-width: 2200px){

  }
  @media screen and (max-width: 1440px){
  .main{
   .about{
       width:90%;
       .ln{
           width:100%;
       }
   }
  }
  }
  @media screen and (max-width: 1000px){
      overflow: hidden;
      .main{
          .about{
              margin: 30px auto;
              .title{
                  font-size: 30px;
              }
              .intro{
                  margin: 15px auto;
                  width:100%;
                  p{
                      font-size: 16px;
                  }
                  div{
                      margin: 30px auto;
                      height:auto;
                  }
              }
          }
          .market{
              flex-direction: column;
              padding: 30px 0;
              .l{
                  width:90%;
                  margin: 0 auto;
                  p:nth-child(1){
                      font-size: 30px;
                      padding: 20px 0;
                  }
              }
          }
      }
  }
}
</style>
